import store from '@/store';
import Vue from 'vue';

Vue.filter('asStatus', (id) => store.getters.say[`statuses_${id}`]);
